import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import { PAGINEDETAIL } from 'utils/endpoint'
import { api, CAS_DOMAIN } from 'utils'
import ListingAlgolia from 'components/ListingAlgolia'
import Head from 'next/head'
import { useRouter } from 'next/router'

const RisorseHub = ({ pagina, statusCode }) => {
  if (!pagina) return <Error statusCode={statusCode} />

  const background = pagina.main_image
    ? { backgroundImage: `url(${pagina.main_image})` }
    : { backgroundColor: `black` }

  const filtriDisponibili = [
    'visibilita', // custom
    'Classe',
    'Eta',
    'Disciplina',
    'models', // custom
    'Tipo Strumento',
  ]

  const router = useRouter()
  const canonical = router.asPath.split('?')[0]

  return (
    <>
      {pagina ? (
        <>
          <MetaSeo seo={pagina.seo} />
          <Head>
            {pagina.main_image ? <link rel="preload" href={pagina.main_image} as="image" /> : null}
            <link rel="canonical" href={CAS_DOMAIN + canonical} />
          </Head>
          <main className="listing-page">
            <div
              className="w-container-fluid u-before-section u-background-image"
              style={background}
            >
              <div className="w-container">
                <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
              </div>

              <section className="listing-page__header">
                <div className="w-container">
                  <h1 className="listing-page__title">{pagina.titolo}</h1>
                </div>
              </section>
            </div>
            <section className="listing-page__list-section section">
              <ListingAlgolia
                filtriInitial={pagina.valori_attributo}
                filtriDisponibili={filtriDisponibili}
              />
            </section>
          </main>
        </>
      ) : null}
    </>
  )
}

export const getStaticProps = async () => {
  const response = await api.get(PAGINEDETAIL, {
    params: { path: '/scuola-dell-infanzia/risorse' },
  })
  const pagina = await response.data

  const toolbarProps = { toolbarPage: pagina }

  return { props: { pagina, ...toolbarProps, key: pagina.id }, revalidate: 60 * 2 }
}

export default RisorseHub
